/**
 * Whether an Evidence chat carries session or patient clinical context.
 *
 * Backend-persisted IDs always disqualify sharing (PHI). When mid-chat persist
 * is enabled, staged outgoing link ids also disqualify share before the next
 * completion persists them — mirrors mobile EVI-2279 consume.
 */
export function isEvidenceChatClinicallyLinked(params: {
  backendSessionId?: string | null;
  backendPatientProfileId?: string | null;
  linkedSessionId?: string | null;
  linkedPatientProfileId?: string | null;
  /** When true, staged mid-chat link atoms also block share. EVI-2279. */
  includeOutgoingLinks?: boolean;
}): boolean {
  if (params.backendSessionId || params.backendPatientProfileId) {
    return true;
  }

  if (!params.includeOutgoingLinks) {
    return false;
  }

  return !!(params.linkedSessionId || params.linkedPatientProfileId);
}
